module.exports = __webpack_public_path__ + "img/blast_logo.ea18c3e6.png";